import { Modal, Typography, Button } from "antd";
import { useHistory } from "react-router-dom/cjs/react-router-dom.min";
import { useDispatch } from "react-redux";
import { actions } from "../slice";
import { FaCheckCircle } from "react-icons/fa";

const { Text } = Typography;

function AcceptanceFormSuccessModal({ open, setOpen, id }) {
  const history = useHistory();
  const dispatch = useDispatch();

  const handleOpenLabelingForm = () => {
    setOpen(false);
    dispatch(
      actions.fetchOrderDetails({
        id,
        onSuccess: (id) => {
          dispatch(actions.fetchSampleDetails(id));
        },
        onFailure: () => {},
      })
    );
  };
  return (
    <>
      <Modal
        title={
          // <Text style={{ fontSize: 18, fontWeight: 600 }}>

          // </Text>
          <span
            style={{
              display: "flex",
              alignItems: "center",
              gap: 8,
              fontSize: 18,
              fontWeight: 600,
            }}
          >
            Acceptance Form Completed
            <FaCheckCircle size={24} color="#2E7D32" />
          </span>
        }
        visible={open}
        centered
        onCancel={() => {}}
        bodyStyle={{ borderRadius: 8, padding: 32, minHeight: 130 }}
        style={{ borderRadius: 8, overflow: "hidden", minWidth: 400 }}
        footer={[
          <Button
            key="goBack"
            onClick={() => {
              history.goBack();
            }}
            style={{ fontWeight: 500, fontSize: 16 }}
          >
            Do It Later
          </Button>,
          <Button
            key="confirm"
            type="primary"
            style={{ fontWeight: 500, fontSize: 16 }}
            onClick={handleOpenLabelingForm}
          >
            Open Labeling Form
          </Button>,
        ]}
      >
        <Text style={{ fontSize: 16, color: "#9b9ea4ff", fontWeight: 600, }}>
          Acceptance details saved successfully. Would you like to open the
          Labeling form or do it later?{" "}
        </Text>
      </Modal>
    </>
  );
}

export default AcceptanceFormSuccessModal;
